import { formatEnvURL } from "../util/env"

const httpRequest = async (url, init) => {
    const resp = await fetch(url, {...init, credentials: "include"})

    if (window.location.href.includes("/login") || window.location.href.includes("redirect")) {
        // we are already here, do not navigate
        return
    }

    if (resp.status === 401) {
        window.location.href = "/login"
        return
    }

    return resp
}

export const fetchAllFromGallery = async (blueprintId) => {
    const res = await httpRequest(formatEnvURL(`gallery/list?id=${blueprintId}&type=bid`))
    return res.json()
}

export const fetchBlueprints = async () => {
    const res = await httpRequest(formatEnvURL("blueprint/list"))
    return res.json()
}

export const getBlueprint = async (blueprintId) => {
    const res = await httpRequest(formatEnvURL(`blueprint/list?id=${blueprintId}`))
    return res.json()
}

export const createBlueprint = async (data) => {
    const res = await httpRequest(formatEnvURL("blueprint/new"), {
        method: "POST",
        body: JSON.stringify(data),
    })

    return res.json()
}

export const fetchTasks = async (projectId) => {
    const res = await httpRequest(formatEnvURL(`task/list?id=${projectId}&type=bId`), {
        method: "GET",
    })

    return res?.json()
}

export const fetchCompileStatus = async (projectId) => {
    if (projectId === undefined) {
        return {}
    }
    const res = await httpRequest(formatEnvURL(`blueprint/compile-status?id=${projectId}`), {
        method: "GET",
    })

    return res?.json()
}

export const getTaskById = async (taskId) => {
    try {
        const res = await httpRequest(formatEnvURL(`task/list?id=${taskId}`), {
            method: "GET",
        })

        if (!res.ok) {
            throw new Error(`Request failed with status ${res.status}`)
        }

        return await res.json()
    } catch (error) {
        console.error("Error fetching task:", error)
        return undefined
    }
}

export const getQueuedTasks = async () => {
    const res = await httpRequest(formatEnvURL(`task/list`), {
        method: "GET",
    })
    return res?.json()
}

export const deleteProject = async (projectId) => {
    await httpRequest(formatEnvURL(`blueprint/delete?id=${projectId}`), {
        method: "PUT",
    })
}

export const saveProjectSettings = async (data) => {
    await httpRequest(formatEnvURL("blueprint/settings"), {
        method: "PUT",
        body: JSON.stringify(data),
    })
}
export const getProjectSettings = async (projectId) => {
    const res = await httpRequest(formatEnvURL(`blueprint/settings?id=${projectId}`), {
        method: "GET",
    })
    return res?.json()
}

export const saveProject = async (data) => {
    await httpRequest(formatEnvURL(`blueprint/save`), {
        method: "PUT",
        body: JSON.stringify(data),
    })
}

export const runBlueprint = async (data) => {
    const res = await httpRequest(formatEnvURL("blueprint/run"), {
        method: "POST",
        body: JSON.stringify(data),
    })
    const json = await res?.json()
    return {
        data: json,
        httpStatus: res.status,
    }
}

export const retriggerTask = async ({
    taskId,
    id,
}) => {
    const res = await httpRequest(formatEnvURL("blueprint/rerun"), {
        method: "POST",
        body: JSON.stringify({ taskId, id }),
    })

    const json = await res?.json()
    return {
        data: json,
        httpStatus: res.status,
    }
}

export const uploadMediaDeprecated = async (file, activeProjectId) => {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("blueprintId", activeProjectId)

    const res = await httpRequest(formatEnvURL(`media/upload`), {
        method: "POST",
        body: formData,
    })
    const d = await res.json()

    if (res.status !== 200) {
        throw Error(d["message"])
    }
    return d["id"]
}

export const uploadMedia = async (file, activeProjectId) => {    
    const resp = await httpRequest(formatEnvURL("media/sign"), {
        method: "POST",
        body: JSON.stringify({
            blueprintId: activeProjectId,
            filename: file?.name,
            contentType: file?.type,
            size: file?.size,
        })
    })

    const { url, fields, capacity, id } = await resp.json()
    if (file.size > capacity) throw new Error("too large")

    const form = new FormData()
    Object.entries(fields).forEach(([k, v]) => form.append(k, v))
    form.append("file", file)

    const up = await fetch(url, { method: "POST", body: form })

    if (up.status !== 204) throw new Error(`upload failed: ${up.status}`)
    
    return id
}

export const fetchMedia = async (mediaId) => {
    const res = await httpRequest(formatEnvURL(`media/?id=${mediaId}`))
    return res.json()
}

export const getMe = async () => {
    const res = await httpRequest(formatEnvURL("accounts/me"))
    return res.json()
}

export const postPaymentSession = async (stripePriceId) => {
    const response = await httpRequest(formatEnvURL("payment/session"), {
        method: "POST",
        body: JSON.stringify({ price: stripePriceId }),
    })

    return response.json()
}

export const getCurrentPlan = async () => {
    const response = await httpRequest(formatEnvURL("payment/plan"))
    return response.json()
}

export const postConnection = async (accountId, value) => {
    const response = await httpRequest(formatEnvURL("accounts/connection"), {
        method: "POST",
        body: JSON.stringify({ accountId, value }),
    })

    return response.json()
}

export const listConnections = async () => {
    const response = await httpRequest(formatEnvURL("accounts/connection/list"))
    return response.json()
}

export const deleteConnection = async (id) => {
    await httpRequest(formatEnvURL("accounts/connection/delete"), {
        method: "PUT",
        body: JSON.stringify({ id }),
    })
}

export const getMeSettings = async () => {
    const response = await httpRequest(formatEnvURL("accounts/me/settings"))
    return response.json()
}

export const putUserSettings = async (request) => {
    await httpRequest(formatEnvURL("accounts/me/settings"), {
        method: 'PUT',
        body: JSON.stringify(request)
    })    
}

export const getAccountPlans = async () => {
    const response = await httpRequest(formatEnvURL("config/plans"))
    return response.json()
}

export const proxyGetElevenVoices = async () => {
    const response = await httpRequest(formatEnvURL("proxy/elevenlabs/voices"))
    return response.json()
}

export const proxyGetOpenAIModels = async () => {
    const response = await httpRequest(formatEnvURL("proxy/openai/models"))
    return response.json()
}


export const proxyAzureAiFoundryModels = async () => {
    const response = await httpRequest(formatEnvURL("proxy/azure/models"))
    return response.json()
}

export const deleteGalleryEntry = async (id) => {
    await httpRequest(formatEnvURL(`gallery/delete?id=${id}`), {
        method: 'PUT'
    })
}

export const listNotifications = async () => {
    const response = await httpRequest(formatEnvURL(`notification/list`))
    return response.json()
}

export const completeNotifications = async () => {
    await httpRequest(formatEnvURL(`notification/complete`), {
        method: 'PUT'
    })
}

export const configFonts = async () => {
    const response = await httpRequest(formatEnvURL(`config/fonts`), {
        method: 'GET'
    })

    return response.json()
}

export const signout = async () => {
    await httpRequest(formatEnvURL(`accounts/signout`), {
        method: 'PUT'
    })
}

export const configColors = async () => {
    const response = await httpRequest(formatEnvURL(`config/colors`), {
        method: 'GET'
    })

    return response.json()
}

export const saveSnapshot = async (request) => {
    await httpRequest(formatEnvURL(`blueprint/snapshot`), {
        method: 'PUT',
        body: JSON.stringify(request)
    })
}

export const getMeImportant = async () => {
    const response = await httpRequest(formatEnvURL(`accounts/me/important`), {
        method: 'GET'
    })

    return response.json()
}

export const submitFeedback = async (data) => {
    await httpRequest(formatEnvURL(`feedback/submit`), {
        method: 'POST',
        body: JSON.stringify(data)
    })
}

export const postCheckoutSession = async (data) => {
    const response = await httpRequest(formatEnvURL(`payment/checkout`), {
        method:'POST',
        body: JSON.stringify(data)
    })

    return response.json()
}

export const postTemplateSave = async (data) => {
    const response = await httpRequest(formatEnvURL(`blueprint/template`), {
        method:'POST',
        body: JSON.stringify(data)
    })

    return response.json()
}

export const getTheme = async () => {
    const response = await httpRequest(formatEnvURL(`accounts/me/theme`), {
        method: 'GET'
    })

    return response.json()
}

export const setTheme = async (theme) => {
    const res = await httpRequest(formatEnvURL(`accounts/me/theme`), {
        method: 'PUT',
        body: JSON.stringify({theme})
    })

    return res.status === 200
}

export const listMediaByBlueprintID = async (blueprintId) => {
    const res = await httpRequest(formatEnvURL(`media/list?id=${blueprintId}`))

    return res.json()
}

export const deleteMediaById = async (mediaId) => {
    await httpRequest(formatEnvURL(`media/delete?id=${mediaId}`), {
        method: "PUT"
    })
}


export const clearNotifications = async () => {
    await httpRequest(formatEnvURL(`notification/clear`), {
        method: "PUT"
    })
}

export const createNewBlueprintVersion = async (data) => {
    await httpRequest(formatEnvURL(`version/new`), {
        method: "POST",
        body: JSON.stringify(data)
    })
}

export const listBlueprintVersion = async (bid) => {
    const data = await httpRequest(formatEnvURL(`version/list?bid=${bid}`))

    return data.json()
}

export const listBlueprintVersionById = async (id) => {
    const data = await httpRequest(formatEnvURL(`version/list?id=${id}`))

    return data.json()
}
// Delete a blueprint version by ID
export const deleteVersionById = async (versionId) => {
    await httpRequest(formatEnvURL(`version/delete?id=${versionId}`), {
        method: "PUT"
    })
}

export const getDeveloperAPIKeys = async () => {
    const data = await httpRequest(formatEnvURL(`accounts/developer/key`))
    return data.json()
}

export const deleteApiKeys = async (keys) => {
    await httpRequest(formatEnvURL(`accounts/developer/delete-key`), {
        method: "POST",
        body: JSON.stringify({
            keys
        })
    })    
}

export const createDeveloperAPIKeys = async (name) => {
    const data = await httpRequest(formatEnvURL(`accounts/developer/key`), {
        method: "POST",
        body: JSON.stringify({
            name: name,
        })
    })

    return data.json()
}


export const createDeveloperAccount = async () => {
    await httpRequest(formatEnvURL(`accounts/developer`), {
        method: "POST"
    })    
}

export const pollNotifications = async () => {
    const resp = await httpRequest(formatEnvURL('notification/poll'), {
        method: 'GET',
    })

    return resp.json()
}

export const pollQueuedTasks = async () => {
    const resp = await httpRequest(formatEnvURL('task/queued'), {
        method: 'GET',
    })

    return resp.json()
}

export const verifyGoogleOauth = async (params) => {
    await fetch(formatEnvURL('auth/goauth-verify'+params), {
        method: 'GET',
        credentials: "include"
    })
}